import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'
import {
  CircularProgress,
  Grid,
  Typography
} from '@material-ui/core'
import { EmptyList } from '../Atoms'
import { ActiveFilterChips, PaginationControls } from '../Molecules'
import { ClauseList, ModelList } from '../Organisms'

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    marginBottom: 20,
  },
  pagination: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    paddingLeft: "1rem",
    "&>.pagination__buttons": {
      display: "flex"
    }
  },
  results: {
    width: "100%",
    height: "100%",
    flex: "1 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  activeFilters: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
    paddingLeft: "1rem",
    paddingRight: "1rem",
  }
}))

const PaginatedResults = ({ handleClickCard, loading, searchResult, variant }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const PaginationElement = (
    <PaginationControls
      loading={loading}
      totalResults={searchResult ? searchResult.amount : 0}
    />)

  return (
    <div className={classes.root}>
      <div className={classes.activeFilters}>
        <ActiveFilterChips />
      </div>
      <div className={classes.pagination}>
        <Typography variant="body2" component="p">
          {t('search.normalResults', {
            amount: loading
              ? '?'
              : searchResult.amount > 9999
                ? "9999+"
                : searchResult.amount

          })}
        </Typography>
        {PaginationElement}
      </div>
      <div className={classes.results}>
        {loading
          ? <CircularProgress color="primary" />
          : searchResult.amount === 0
            ? <EmptyList />
            : variant === 'clauses'
              ? <ClauseList searchResult={searchResult} handleClickCard={handleClickCard} />
              : <ModelList searchResult={searchResult} handleClickCard={handleClickCard} />
        }
      </div>
      {!loading && searchResult.amount > 0 &&
        <Grid container justifyContent="flex-end" >
          {PaginationElement}
        </Grid>
      }
    </div>
  )
}

export default PaginatedResults
